import React, { Component } from 'react'
import S from 'shorti'
import { Modal, Button } from 'react-bootstrap'
import controller from '../../controller'
import EditBar from '../Partials/EditBar/'
import LayoutsBar from '../Partials/LayoutsBar/'
import ReactGA from 'react-ga'

const { BUILDING } = process.env
class App extends Component {
  constructor() {
    super()
    this.state = {
      data: {
        selected_template: 'light',
        outline_color: '1561bd',
        template_width: '100p'
      }
    }
  }
  componentDidMount() {
    let access_token
    if (this.props.location)
      access_token = this.props.location.query.access_token
    const data = this.state.data
    if (access_token) {
      this.initEditable()
    }
    if (!data.website && !data.is_editable) {
      this.hydrateStateFromTag()
    }
    // Check for domains redirect
    if (this.props.location && this.props.location.query.edit) {
      if (this.props.location.query.edit === 'domains') {
        setTimeout(() => controller.showEditDomainsPanel.bind(this)(), 400)
      }
    }
    // Check for listing website
    if (this.props.location && this.props.location.query.template_type && this.props.location.query.template_type === 'listing')
      setTimeout(() => controller.showListingTemplates.bind(this)(), 400)
  }
  componentDidUpdate() {
    const data = this.state.data
    const website = data.website || this.props.website
    if (!website)
      return
    const brand = website.brand
    if (brand && brand.assets && brand.assets.google_analytics_id) {
      const google_analytics_id = brand.assets.google_analytics_id
      ReactGA.initialize(google_analytics_id)
      ReactGA.set({ page: window.location.pathname })
      ReactGA.pageview(window.location.pathname)
    }
  }
  initEditable() {
    let access_token
    if (this.props.location)
      access_token = this.props.location.query.access_token
    const data = this.state.data
    data.is_editable = true
    this.setState({
      data
    })
    if (window || BUILDING === 'true') {
      this.resizeWidth()
      window.onresize = () => {
        this.resizeWidth()
      }
      if (this.props.location && this.props.location.query.message) {
        if (this.props.location.query.message === 'payment-success' || this.props.location.query.message.indexOf('payment-success') !== -1) {
          this.setState({
            data: {
              ...this.state.data,
              show_payment_success_modal: true
            }
          })
        }
      }
    }
    controller.getWebsites(this, access_token)
    if (this.props.location) {
      if (this.props.location.query.website)
        controller.getWebsite(this, this.props.location.query.website, access_token)
      if (this.props.location.query.listing) {
        controller.selectTemplate(this, 'clean')
        controller.getListing(this, this.props.location.query.listing)
      }
      if (this.props.location.query.template_type) {
        if (this.props.location.query.template_type === 'listing') 
          controller.selectTemplate(this, 'clean')
        else
          controller.selectTemplate(this, 'light')
      }
    }
  }
  selectTemplate(template) {
    controller.selectTemplate(this, template)
  }
  hydrateStateFromTag() {
    const data = this.state.data
    if (typeof window !== 'undefined' && !data.is_editable && window.website_data) {
      data.selected_template = window.website_data.template
      data.template_width = '100p'
      const website = window.website_data
      if (website.brand && !website.brand.assets && website.brand.parent)
        website.brand = website.brand.parent
      this.setState({
        data: {
          ...data,
          website: window.website_data
        }
      })
    }
  }
  getTemplate(template_folder = 'light') {
    const data = this.state.data
    const Template = require(`../Templates/${template_folder}/index`)
    return (
      <Template
        {...this.props}
        data={ data }
        selectTemplate={ this.selectTemplate.bind(this) }
        goToStep={ this.goToStep.bind(this) }
        showModalGallery={ controller.showModalGallery.bind(this) }
        hideModalGallery={ controller.hideModalGallery.bind(this) }
        showListingMap={ controller.showListingMap.bind(this) }
        hideListingMap={ controller.hideListingMap.bind(this) }
      />
    )
  }
  toggleLayoutsBar() {
    const data = this.state.data
    delete data.show_edit_bar
    if (data.show_layouts_bar)
      delete data.show_layouts_bar
    else
      data.show_layouts_bar = true
    this.setState({
      data
    })
    this.resizeWidth()
  }
  toggleEditBar() {
    const data = this.state.data
    delete data.show_layouts_bar
    if (data.show_edit_bar)
      delete data.show_edit_bar
    else
      data.show_edit_bar = true
    this.setState({
      data
    })
    this.resizeWidth()
  }
  resizeWidth() {
    const data = this.state.data
    data.template_width = data.show_layouts_bar || data.show_edit_bar ? window.innerWidth - 400 : window.innerWidth
    this.setState({
      data
    })
  }
  getTemplateName() {
    const data = this.state.data
    if (data.selected_template === 'light')
      return 'LIGHT'
    if (data.selected_template === 'dark')
      return 'DARK'
    if (data.selected_template === 'simple')
      return 'SIMPLE'
    if (data.selected_template === 'retro')
      return 'RETRO'
    if (data.selected_template === 'clean')
      return 'CLEAN'
  }
  goToStep(step) {
    controller.goToStep(this, step)
  }
  goToStore() {
    let access_token
    if (this.props.location)
      access_token = this.props.location.query.access_token
    this.props.router.push(`/store?access_token=${access_token}`)
  }
  render() {
    const data = this.state.data
    let template_folder = data.selected_template
    if (this.props && this.props.website && this.props.website.template)
      template_folder = this.props.website.template
    // console.log(data.selected_template, template_folder)
    const template = this.getTemplate(template_folder)
    // Edit and Layouts Bar
    let edit_bar
    let layouts_bar
    if (data.is_editable) {
      edit_bar = (
        <EditBar
          data={ data }
          goToStep={ this.goToStep.bind(this) }
          uploadMedia={ controller.uploadMedia.bind(this) }
          editText={ controller.editText.bind(this) }
          saveWebsite={ controller.saveWebsite.bind(this) }
          showOverview={ controller.showOverview.bind(this) }
          seachListings={ controller.seachListings.bind(this) }
          selectListing={ controller.selectListing.bind(this) }
          removeSearchListings={ controller.removeSearchListings.bind(this) }
          showEditDomainsPanel={ controller.showEditDomainsPanel.bind(this) }
          addDomainField={ controller.addDomainField.bind(this) }
          removeDomainField={ controller.removeDomainField.bind(this) }
          addDomainValue={ controller.addDomainValue.bind(this) }
          deleteDomain={ controller.deleteDomain.bind(this) }
          addGalleryImage={ controller.addGalleryImage.bind(this) }
          removeAttr={ controller.removeAttr.bind(this) }
        />
      )
      layouts_bar = (
        <LayoutsBar
          data={ data }
          selectTemplate={ this.selectTemplate.bind(this) }
          showAgentTemplates={ controller.showAgentTemplates.bind(this) }
          selectProduct={ controller.selectProduct.bind(this) }
          seachListings={ controller.seachListings.bind(this) }
          selectListing={ controller.selectListing.bind(this) }
          removeSearchListings={ controller.removeSearchListings.bind(this) }
        />
      )
    }
    const header_style = {
      ...S('w-100p h-70 fw-500 font-21 pt-20 pl-30 fixed bg-fff z-2'),
      boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.05), 0 1px 2px 0 rgba(0, 0, 0, 0.05)'
    }
    let edit_header
    if (data.is_editable) {
      edit_header = (
        <div style={ header_style } className="sf">
          <div style={ S('pointer w-200') } onClick={ this.goToStore.bind(this) }><i style={ S('color-2196f3') } className="fa fa-chevron-left"></i>&nbsp;&nbsp;Store Dashboard</div>
          {
            data.show_edit_bar && !data.preview_ready &&
            <Button disabled={ data.preview_loading } onClick={ controller.saveWebsite.bind(this, true) } style={ S('bg-4a4a4a color-fff border-none pull-right w-200 h-42 font-16 absolute t-15 z-0 r-10') }>
              { data.preview_loading ? 'Generating preview...' : 'Live Preview' }
            </Button>
          }
          {
            data.show_edit_bar && data.preview_ready &&
            <a className="btn btn-default" href={ data.preview_url } target="_blank" onClick={ controller.resetPreview.bind(this) } style={ S('bg-4a4a4a color-fff border-none pull-right w-150 h-42 font-16 absolute t-15 z-0 r-10 pt-10') }>
              View Now
            </a>
          }
          {
            data.show_layouts_bar &&
            <Button onClick={ this.goToStep.bind(this, 1) } style={ S('bg-2196f3 color-fff border-none pull-right w-260 h-42 font-16 absolute t-15 z-0 r-10') }>
              Edit Template
            </Button>
          }
        </div>
      )
    }
    return (
      <div style={ S('absolute w-100p h-100p') }>
        { edit_header }
        <div style={ S(`w-${data.template_width} relative ${data.show_layouts_bar ? 'pull-right' : 'pull-left'}${data.is_editable ? ' p-85' : ''} bg-f7f7f7`) }>
          { template }
          <div className="franklin">
            { data.show_layouts_bar ? layouts_bar : '' }
            { data.show_edit_bar ? edit_bar : '' }
          </div>
          {
            data.is_editable && !this.props.location.query.website &&
            <div style={ S(`fixed b-10 z-100 l-${data.show_layouts_bar ? '400' : '0'} bg-4e5c6c p-10 pointer`) } onClick={ this.toggleLayoutsBar.bind(this) }>
              <i className={`fa fa-${data.show_layouts_bar ? 'times' : 'chevron-right'}`} style={ S('color-fff') }></i>
            </div>
          }
        </div>
        <Modal className="futura" show={data.show_website_saved_modal} onHide={controller.closeModal.bind(this)}>
          <div style={ S('absolute r-20 t-10 z-1 pointer font-18') } onClick={controller.closeModal.bind(this)}>&times;</div>
          <Modal.Body>
            <div style={ S('text-center') }>
              <div>
                <svg className="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"><circle className="checkmark__circle" cx="26" cy="26" r="25" fill="none"/><path className="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg>
              </div>
              <div style={ S('font-22 mb-30 mt-30n') }>
                Website Saved!
              </div>
            </div>
          </Modal.Body>
        </Modal>
        <Modal className="futura" show={data.show_payment_success_modal} onHide={controller.closeModal.bind(this)}>
          <div style={ S('absolute r-20 t-10 z-1 pointer font-18') } onClick={controller.closeModal.bind(this)}>&times;</div>
          <Modal.Body>
            <div style={ S('text-center') }>
              <div>
                <svg className="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"><circle className="checkmark__circle" cx="26" cy="26" r="25" fill="none"/><path className="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg>
              </div>
              <div style={ S('font-32 mb-10 mt-30n') }>
                Order Successful!
              </div>
              <div style={ S('mb-20') }>
                <p>You can edit your payment information <br />
                  anytime in your account settings.
                </p>
              </div>
              <div style={ S('mb-20') }>
                <Button onClick={controller.closeModal.bind(this)} bsStyle="primary" bsSize="large">Close</Button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    )
  }
}
module.exports = App


// WEBPACK FOOTER //
// ./src/components/App/index.js